<p-dialog [header]="dialogHeader" [(visible)]="displayImportSample" [modal]="true" [responsive]="true"
    [style]="{width: '30vw'}" (onHide)="closeDialog()" styleClass="import-details-dialog">
    <div class="p-grid" style="height: 400px;">
        <div class="p-col-12">
            <div class="card">
                <div class="p-d-flex">
                    <div>
                        <h6>Select Fields for File Header</h6>
                    </div>
                </div>
                <div class="">
                    <div>
                        <input type="text" class="inputStyle p-inputtext" pInputText placeholder="Search for fields"
                            [(ngModel)]="listSearchInput">
                    </div>
                    <div class="p-d-flex p-ai-center gap-1 p-mt-2 ml-custom">
                        <p-checkbox binary="true" inputId="binary" class="p-mr-2"
                            (onChange)="enableAllSectionFields($event,sectionColumns)">
                        </p-checkbox>
                        <label for="binary"><strong>Select All Fields</strong></label>
                    </div>
                    <hr style="margin: 0.5rem;">
                    <div cdkDropList [cdkDropListData]="sectionColumns" (cdkDropListDropped)="dropListSection($event)">
                        @for (section of sectionColumns; track section.name) {
                            @if((section.fields | gblFilter: listSearchInput: 'name':'childFields')?.length>0)
                            {
                                <div class="colList" cdkDrag (cdkDragStarted)="cdkDragStarted()"
                                    (cdkDragReleased)="cdkDragReleased()">
                                    <div>
                                        <h6 class="sectionLabel">
                                            <i class="pi p-mr-3" (click)="toggleSection(section)"
                                                [ngClass]="{'pi-minus': (!section?.isToogle || listSearchInput),'pi-plus': !(!section?.isToogle || listSearchInput)}"></i>
                                            <p-checkbox type="checkbox" binary="true" inputId="binary" class="p-mr-2"
                                                (onChange)="enableSectionFields($event,section)" [disabled]="isSelectAllSectionField"></p-checkbox>
                                            {{section.name}}
                                        </h6>
                                    </div>
                                    <div *cdkDragPreview>
                                        <h6 class="sectionLabel p-pl-3" style="min-width: 200px;">{{section.name}}</h6>
                                    </div>
                                    @if ((!section.isToogle && showContent) || (listSearchInput && showContent)) {
                                    <div class="sub-columns" cdkDropList [cdkDropListData]="section.fields"
                                        (cdkDropListDropped)="dropCol($event)">
                                        @for (col of section.fields | gblFilter:listSearchInput:'labelName':'childFields'; track
                                        col.field) {
                                        <div class="colList" cdkDrag appendTo="body" *ngIf="col.labelName">
                                            <div class="p-d-flex">
                                                <i class="fa fa-bars p-mt-1" style="margin-right: 10px; color:lightgray"></i>
                                                <p-checkbox [(ngModel)]="col.ischecked"
                                                    *ngIf="(col?.childFields?.length||0) === 0"
                                                    [disabled]="(col?.isDisabled && col.ischecked)"
                                                    type="checkbox" binary="true" inputId="binary" class="p-mr-2">
                                                </p-checkbox>
                                                <span class="p-mt-1">{{col.labelName}}</span>
                                                <button type="button" pButton pRipple
                                                    class="p-button-text p-button-rounded p-button-plain p-ml-2"
                                                    [icon]="col.showChildrens ? 'pi pi-minus' : 'pi pi-plus'"
                                                    *ngIf="col?.childFields?.length > 0" (click)="showChild(col)"
                                                    style="height: 20px; width: 20px;"></button>
                                            </div>
                                            @if(col?.childFields?.length > 0 &&
                                            (col.showChildrens || (listSearchInput &&
                                            (col?.childFields | gblFilter:
                                            listSearchInput:'labelName':'childFields')?.length>0)))
                                            {
                                                <ul>
                                                    @for (childCol of col.childFields; track childCol.labelName) {
                                                    <li>
                                                        <p-checkbox [(ngModel)]="childCol.ischecked" type="checkbox" binary="true"
                                                            inputId="binary" class="p-mr-2"></p-checkbox>
                                                        {{childCol.labelName}}
                                                    </li>
                                                    }
                                                </ul>
                                            }
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                            }
                        }
                    </div>

                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <ng-container *ngIf="loadFields">
            <button type="button" pButton label="Save" (click)="fieldsUpdated.emit(sectionColumns)"></button>
        </ng-container>
        <ng-container *ngIf="!loadFields">
            <button type="button" pButton label="CSV" (click)="downLoadExcel('csv')"></button>
            <button type="button" pButton label="Excel" (click)="downLoadExcel()"></button>
        </ng-container>
    </ng-template>
</p-dialog>
